module.exports = __webpack_public_path__ + "static/media/add-two.24d8e095.png";